import React, { useRef } from "react"
import Button from "@material-ui/core/Button"
import Box from "@material-ui/core/Box"
import useNotification from "src/features/Notification/customs"
import BackupIcon from "@material-ui/icons/Backup"

async function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    // Convert the file to base64 text
    reader.addEventListener("load", () => resolve(reader.result))
    reader.onerror = () => {
      return reject("error is occured while reading file as base64")
    }
    reader.readAsDataURL(file)
  })
}

function Index({ disabled, onUpload, img_size = 250 }) {
  const { showError } = useNotification()
  const ref = useRef()
  //
  const handleChangeFile = async (event) => {
    const file = event.target.files[0]
    if (file.size > 10000000) {
      showError("The file size is more than 10MB, please use another image.")
    } else {
      const img = await getBase64(file)
      onUpload(img)
    }
  }

  const upload = () => {
    ref.current.click()
  }

  return (
    <>
      <Button onClick={upload} disabled={disabled} variant="outlined">
        UPLOAD <Box component={BackupIcon} ml={1} />
      </Button>
      <input
        ref={ref}
        hidden
        type="file"
        accept="image/*"
        onChange={handleChangeFile}
      />
    </>
  )
}

export default Index
